import React, { type CSSProperties } from 'react';
import type { LibItemAlbum } from '@types';
import Image from '@components/Image';
import LibItemOperator from '../../layouts/LibItemOperator';
import LibItemRightPart from '../../layouts/LibItemRightPart';
import ImgAlbum from './img-album.png';
import LibItemContainer from '../../layouts/LibItemContainer';
import LibItemName from '../../layouts/LibItemName';
import LibItemDate from '../../layouts/LibItemDate';
import onAlbumClick from '../../actions/onAlbumClick';

type Props = {
  style?: CSSProperties;
  data: LibItemAlbum;
};

function AlbumItem({ style, data }: Props) {
  return (
    <LibItemContainer style={style} onClick={() => onAlbumClick(data.id)}>
      <div className="w-16 flex-shrink-0" />
      <Image src={ImgAlbum} size={32} className="ml-20 h-32 w-32" />
      <LibItemName>{data.name}</LibItemName>
      <LibItemRightPart>
        <LibItemOperator name={data.operatorName} />
        <LibItemDate date={data.updateDate} createDate={data.createDate} />
      </LibItemRightPart>
    </LibItemContainer>
  );
}

export default AlbumItem;
